import Alpine from "alpinejs";
import RegisterForm from ":/components/RegisterForm";
import VerificationCode from ":/components/VerificationCode";

Alpine.data('RegisterForm', RegisterForm)
Alpine.data('VerificationCode', VerificationCode)
